import { useState } from 'react'
import { BellRing } from 'lucide-react'
import UserReminderClickLogsTab from './UserReminderClickLogsTab'
import UserReminderShowLogsTab from './UserReminderShowLogsTab'
import UserReminderRewardRecordsTab from './UserReminderRewardRecordsTab'
import UserReminderCashbackWithdrawalsTab from './UserReminderCashbackWithdrawalsTab'
import ChannelReminderClickLogsTab from './ChannelReminderClickLogsTab'

const SUB_TABS = [
  { id: 'user-reminder-click-logs', label: '用户弹窗点击', icon: BellRing },
  { id: 'user-reminder-show-logs', label: '用户弹窗情况', icon: BellRing },
  { id: 'user-reminder-reward-records', label: '弹窗奖励记录', icon: BellRing },
  { id: 'user-reminder-cashback-withdrawals', label: '弹窗提现审核', icon: BellRing },
  { id: 'user-reminder-channel-click-logs', label: '渠道弹窗点击', icon: BellRing }
]

export default function UserReminderTab() {
  const [activeSubTab, setActiveSubTab] = useState('user-reminder-click-logs')

  const renderContent = () => {
    switch (activeSubTab) {
      case 'user-reminder-show-logs':
        return <UserReminderShowLogsTab />
      case 'user-reminder-reward-records':
        return <UserReminderRewardRecordsTab />
      case 'user-reminder-cashback-withdrawals':
        return <UserReminderCashbackWithdrawalsTab />
      case 'user-reminder-channel-click-logs':
        return <ChannelReminderClickLogsTab />
      case 'user-reminder-click-logs':
      default:
        return <UserReminderClickLogsTab />
    }
  }

  return (
    <div className="space-y-6">
      <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm dark:border-gray-700 dark:bg-gray-800">
        <div className="flex flex-wrap gap-3">
          {SUB_TABS.map((tab) => {
            const Icon = tab.icon
            const isActive = activeSubTab === tab.id

            return (
              <button
                key={tab.id}
                onClick={() => setActiveSubTab(tab.id)}
                className={`inline-flex items-center gap-2 rounded-lg border px-4 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? 'border-blue-200 bg-blue-50 text-blue-700 dark:border-blue-800 dark:bg-blue-900/30 dark:text-blue-400'
                    : 'border-gray-200 bg-gray-50 text-gray-600 hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-900/50 dark:text-gray-400 dark:hover:bg-gray-700'
                }`}
              >
                <Icon className="h-4 w-4" />
                {tab.label}
              </button>
            )
          })}
        </div>
      </div>

      {renderContent()}
    </div>
  )
}
